module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.svg
// module chunks = styles